module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_en-479c83676ed80bba25a1a251e6366886.jpg";